import React from 'react';
import PropTypes from 'prop-types';
import { Box, Toolbar, Typography } from '@mui/material';
import { Icon } from '@mui/material';

import CustomSearch from 'components/common/customSearchV2';
import CustomFilter from 'components/common/customFilter';
import CustomToolbarAction from 'components/common/customToolbarAction';
import M from 'messages';

import classes from './styles';

const CustomTableToolbar = props => {
  const {
    onSearchCallback,
    filteredParams,
    onFilterCallback,
    filterFields,
    isNeedMakePublicAction,
    isNeedMakePrivateAction,
    handleStatusChange,
    numSelected = 0,
    handleDelete,
  } = props;

  const searchValue = filteredParams?.params?.search?.value || '';

  return (
    <Toolbar sx={classes.root}>
      <Box sx={classes.filters}>
        <CustomSearch onSearchCallback={onSearchCallback} searchValue={searchValue} />
        <CustomFilter onFilterCallback={onFilterCallback} filterFields={filterFields} filteredParams={filteredParams} />
      </Box>
      <Box sx={classes.actions}>
        {numSelected > 0 && (
          <Typography sx={classes.headerText}>{`${numSelected} ${M.get('table.itemSelected')}`}</Typography>
        )}
        {numSelected > 0 && handleDelete && (
          <CustomToolbarAction
            handleOnClick={handleDelete}
            btnText={M.get('actions.delete')}
            tooltipText={M.get('actions.delete')}
            startIcon={<Icon>delete_forever</Icon>}
          />
        )}
        {isNeedMakePublicAction && (
          <CustomToolbarAction
            handleOnClick={() => handleStatusChange('public')}
            btnText={M.get('actions.makePublic')}
            tooltipText={M.get('actions.makePublic')}
            startIcon={<Icon>visibility</Icon>}
          />
        )}
        {isNeedMakePrivateAction && (
          <CustomToolbarAction
            handleOnClick={() => handleStatusChange('private')}
            btnText={M.get('actions.makePrivate')}
            tooltipText={M.get('actions.makePrivate')}
            startIcon={<Icon>visibility_off</Icon>}
          />
        )}
      </Box>
    </Toolbar>
  );
};

CustomTableToolbar.propTypes = {
  onSearchCallback: PropTypes.func.isRequired,
  filteredParams: PropTypes.instanceOf(Object).isRequired,
  onFilterCallback: PropTypes.func.isRequired,
  filterFields: PropTypes.instanceOf(Object).isRequired,
  handleStatusChange: PropTypes.func.isRequired,
  isNeedMakePublicAction: PropTypes.bool.isRequired,
  isNeedMakePrivateAction: PropTypes.bool.isRequired,
  numSelected: PropTypes.number,
  handleDelete: PropTypes.func,
};

export default CustomTableToolbar;
